module.exports = __webpack_public_path__ + "media/Audio17_g.ff8606ed.wav";